var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHashsearch = function SvgHashsearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#18A87D",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.74 5.337c.366.041.63.37.59.737l-.363 3.26h2.659l.378-3.408a.667.667 0 0 1 1.325.148l-.362 3.26h2.366a.667.667 0 0 1 0 1.333H14.82l-.296 2.666h2.81a.667.667 0 1 1 0 1.334h-2.959l-.378 3.406a.667.667 0 1 1-1.325-.147l.362-3.26h-2.659l-.378 3.407a.667.667 0 1 1-1.325-.147l.362-3.26H6.667a.667.667 0 0 1 0-1.333H9.18l.296-2.666h-2.81a.667.667 0 0 1 0-1.334h2.958l.379-3.407c.04-.366.37-.63.736-.589m.079 5.33-.296 2.666h2.658l.296-2.666z",
    clipRule: "evenodd"
  })));
};
export default SvgHashsearch;